module.exports = __webpack_public_path__ + "media/images/brands/marque-lci-bce8181feaa4bd32ce33328c7872307b.jpg";